export const BASE_LAYERS = ["os", "k8s", "cni", "csi"];

export const ADDON_LAYERS = [
  "load balancer",
  "ingress",
  "logging",
  "monitoring",
  "security",
  "authentication",
  "system app",
  "servicemesh",
  "registry",
  "spectro",
];

const COMMON_STEPS = ["name", "version", "overview"];

export let PACK_STEPS = BASE_LAYERS.reduce((accumulator, layerType) => {
  accumulator[layerType] = COMMON_STEPS;
  return accumulator;
}, {});

ADDON_LAYERS.forEach((layerType) => {
  PACK_STEPS[layerType] = ["type", ...COMMON_STEPS];
});

PACK_STEPS.k8s = ["version", "overview"];
PACK_STEPS.new = ["type", ...COMMON_STEPS];
